import { motion } from 'framer-motion';

export default function ContactSection() {
  return (
    <section id="contact" className="contact" aria-labelledby="contact-heading">
      <div className="container">
        <motion.div className="contact__panel" initial={{ opacity: 0, y: 12 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.35 }}>
          <div>
            <p className="eyebrow">Let’s connect</p>
            <h2 id="contact-heading" className="section-heading">Have an idea worth building?</h2>
            <p className="section-intro">I’m always glad to meet people working on thoughtful technical problems.</p>
          </div>
          <div className="contact__links">
            <a className="button button--primary" href="mailto:rafaperales1229@gmail.com">Email me</a>
            <a className="button button--secondary" href="https://www.linkedin.com/in/rafaelperales2027" target="_blank" rel="noreferrer">LinkedIn ↗</a>
            <a className="button button--secondary" href="https://github.com/rafaelperales05" target="_blank" rel="noreferrer">GitHub ↗</a>
          </div>
        </motion.div>
        <footer className="site-footer"><span>© {new Date().getFullYear()} Rafael Perales</span><span>Designed and built with intent.</span></footer>
      </div>
    </section>
  );
}
